import * as React from 'react';
import { view, createView } from '@sail/engine';
export const ToastButton = createView(({ children, ...props })=>{
    return /*#__PURE__*/ React.createElement(view.button, props, /*#__PURE__*/ React.createElement(view.span, {
        css: {
            transform: 'translateY(var(--content-offset-y))'
        }
    }, children));
}, {
    css: {
        stack: 'x',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        padding: 'medium',
        backgroundColor: 'transparent',
        transition: 'all .05s ease-in-out',
        '--content-offset-y': '0px',
        ':focus-within': {
            focusRing: 'focus'
        },
        ':hover:not(:active)': {
            backgroundColor: 'translucent'
        },
        ':active:not([aria-disabled="true"])': {
            '--content-offset-y': '1px'
        }
    }
});

//# sourceMappingURL=ToastButton.js.map